// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.search.dto.HpSearchOrderBy

export enum HpSearchOrderBy {
  PRICE_ASC = 'priceAsc',
  PRICE_DESC = 'priceDesc',
  SCORE_DESC = 'scoreDesc',
  TIME_ACTIVATED_DESC = 'timeActivatedDesc',
  VIEWS_DESC = 'viewsDesc',
}

export const HpSearchOrderBy_values = [
  HpSearchOrderBy.PRICE_ASC,
  HpSearchOrderBy.PRICE_DESC,
  HpSearchOrderBy.SCORE_DESC,
  HpSearchOrderBy.TIME_ACTIVATED_DESC,
  HpSearchOrderBy.VIEWS_DESC,
] as const;
